import * as React from "react";
import { CustomerNotifications } from "src/components/shared/CustomerNotifications";
import { NotificationLocation } from "__generated__/api";
import { CustomerNotificationsWrapperProps } from "./typings";
import { CustomerNotificationsInPage } from "src/components/shared/StorefrontWizard/TravelAdvisory/CustomerNotificationsInPage";

export const CustomerNotificationsWrapper = (props: CustomerNotificationsWrapperProps) => {
  const { location, className, reasonsToBelieve, reasonsToBelieveVersion } = props.flexComponent.model;

  const notificationLocations = {
    [NotificationLocation.AFTER_HEADER]: NotificationLocation.AFTER_HEADER,
    [NotificationLocation.FOOTER]: NotificationLocation.FOOTER,
    [NotificationLocation.IN_PAGE]: NotificationLocation.IN_PAGE,
    [NotificationLocation.IN_PAGE_AD]: NotificationLocation.IN_PAGE_AD,
    [NotificationLocation.POPUP]: NotificationLocation.POPUP,
    [NotificationLocation.PRE_HEADER]: NotificationLocation.PRE_HEADER,
  };

  const notificationLocation = notificationLocations[location];
  if (!notificationLocation) {
    return null;
  }

  const moduleToRender =
    reasonsToBelieve && location == notificationLocations.IN_PAGE ? (
      <div className="ReasonsToBelieveWrapper" data-testid="reasons-to-believe-wrapper">
        <CustomerNotificationsInPage reasonsToBelieveVersion={reasonsToBelieveVersion} />
      </div>
    ) : (
      <div className="CustomerNotificationsWrapper" data-testid="customer-notifications-wrapper">
        <CustomerNotifications location={location} className={className} />
      </div>
    );

  return moduleToRender;
};

export default CustomerNotificationsWrapper;
